import { useState } from "react";
import * as Icon from "react-feather";

import { connect } from "react-redux";

import Button from "../common/Button";
import Card from "../common/Card";
import Form from "../common/Form";
import Page from "../common/Page";
import { AuthActionCreators } from "../../store/actions/auth";

const initialState = {
  errorMessage: null,
  infoMessage: null,
  errors: {
    password: null,
    password2: null,
  },
  loading: false,
  values: {
    password: "",
    password2: "",
  },
};

const AuthChangePassword = ({ userId, changePassword }) => {
  const [password, setPassword] = useState(initialState.values.password);
  const [password2, setPassword2] = useState(initialState.values.password2);
  const [errors, setErrors] = useState(initialState.errors);
  const [loading, setLoading] = useState(initialState.loading);
  const [errorMessage, setErrorMessage] = useState(initialState.errorMessage);
  const [infoMessage, setInfoMessage] = useState(initialState.infoMessage);

  const onBlur = (e) => {
    e && e.preventDefault();
    const errorsVar = errors;
    if (!e.target.value.length) {
      errorsVar[e.target.name] = "This is a required field!";
    } else {
      errorsVar[e.target.name] = null;
    }
    setErrors(errorsVar);
  };

  const onChange = (e) => {
    e && e.preventDefault();
    if (e.target.name === "password") setPassword(e.target.value);
    if (e.target.name === "password2") setPassword2(e.target.value);
  };

  const onSubmit = (e) => {
    e && e.preventDefault();
    setErrors(initialState.errors);
    setErrorMessage(initialState.errorMessage);
    setLoading(true);
    if (password !== password2) {
      setErrorMessage("Passwords doesn't match");
      setLoading(false);
    } else {
      setInfoMessage("Your password has changed!");
      setLoading(false);
      changePassword({
        userID: userId,
        password: password.trim(),
      });
    }
  };
  return (
    <Page>
      <div className="max-w-lg flex flex-col">
        <div className="my-auto">
          {errorMessage && (
            <div
              className="bg-red-100 border-l-4 border-red-500 rounded-b text-red-900 px-4 py-3 shadow mb-3"
              role="alert"
            >
              <div className="flex">
                <div className="py-1">
                  <Icon.Info className="h-6 w-6 text-red-500 mr-4" />
                </div>
                <div>
                  <p className="font-bold">Failed</p>
                  <p className="text-sm">{errorMessage}</p>
                </div>
              </div>
            </div>
          )}
          {infoMessage && (
            <div
              className="bg-blue-100 border-l-4 border-blue-500 rounded-b text-blue-900 px-4 py-3 shadow mb-3"
              role="alert"
            >
              <div className="flex">
                <div className="py-1">
                  <Icon.Info className="h-6 w-6 text-blue-500 mr-4" />
                </div>
                <div>
                  <p className="font-bold">Success!</p>
                  <p className="text-sm">{infoMessage}</p>
                </div>
              </div>
            </div>
          )}
          <Card className="p-2">
            <Card.Body>
              <span className="block text-lg mb-5">Change Your Password</span>
              <Form>
                <Form.FormTextInput
                  name="password"
                  type="password"
                  label="New password"
                  placeholder="New password"
                  onChange={onChange}
                  onBlur={onBlur}
                  value={password}
                  error={errors && errors.password}
                />
                <Form.FormTextInput
                  name="password2"
                  type="password"
                  label="Confirm new password"
                  placeholder="Confirm new password"
                  onChange={onChange}
                  onBlur={onBlur}
                  value={password2}
                  error={errors && errors.password2}
                />
                <Button
                  className="w-full"
                  color="login"
                  onClick={onSubmit}
                  type="submit"
                  loading={loading}
                  disabled={loading}
                >
                  Change Password
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </div>
      </div>
    </Page>
  );
};

export default connect(
  (state) => ({
    userId: state.auth.user.id,
  }),
  (dispatch) => ({
    changePassword: (user) => dispatch(AuthActionCreators.changepassword(user)),
  })
)(AuthChangePassword);
